import { styleguideService } from "@Shared/Service/StyleguideService";
import { useEffect, useState } from "react";

// response sample
// {
//   status: "completed",
//   currentStep: 4,
//   buttonCornerRadius: 24,
//   buttonColor: {
//     light: {
//       accentColor: "#1D7AFC",
//       id: "color_1",
//       textColor: "#FFFFFF",
//     },
//     dark: {
//       accentColor: "#5C9AFF",
//       id: "color_1",
//       textColor: "#1E1E1E",
//     },
//   },
//   selectedColors: {
//     lightColors: [
//       {
//         id: "color_1",
//         accentColor: "#1D7AFC",
//         textColor: "#FFFFFF",
//       },
//     ],
//     darkColors: [
//       {
//         id: "color_1",
//         accentColor: "#5C9AFF",
//         textColor: "#1E1E1E",
//       },
//     ],
//   },
//   cornerRadius: 8,
// };

export const useStyleguideSetup = () => {
  const [onboardingData, setOnboardingData] = useState({});

  useEffect(() => {
    styleguideService
      .checkOnboardingStatus()
      .then((response) => {
        if (response?.data) {
          const { status, ...data } = response?.data?.onboarding || {};
          if (Object.keys(data).length && status === "completed") {
            setOnboardingData(data);
          }
        }
      })
      .catch((e) => console.log("ERROR ", e));
  }, []);

  return onboardingData;
};
